/* LP Landing: gallery, variants, quantity, sticky bar, before/after. No dependencies. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    function withDelims(num, dec, thou, sep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(n, 2, "'", '.');
        case 'amount_with_space_separator': return withDelims(n, 2, ' ', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initGallery(root) {
    var track = root.querySelector('[data-lp-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lp-thumb]'));
    if (!track) return function () {};
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lp-dot]'));
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function go(i, smooth) {
      var slide = track.children[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    }
    root.querySelectorAll('[data-lp-gallery-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = track.children.length;
        go((current + Number(b.getAttribute('data-lp-gallery-step')) + n) % n, true);
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.getAttribute('data-lp-thumb')), true); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setActive(i);
      });
    }, { passive: true });
    return function goToMediaId(id) {
      var slides = track.children;
      for (var k = 0; k < slides.length; k++) {
        if (String(slides[k].getAttribute('data-media-id')) === String(id)) { go(k, true); return; }
      }
    };
  }

  function initProduct(root) {
    var product = readJSON(root, '[data-lp-product-json]');
    var moneyFormat = readJSON(root, '[data-lp-money-format]');
    var form = root.querySelector('.lp-form');
    var goToMedia = initGallery(root);
    var idInput = root.querySelector('[data-lp-variant-id]');
    var addBtn = root.querySelector('[data-lp-add]');
    var addLabel = root.querySelector('[data-lp-add-label]');
    var defaultLabel = addLabel ? addLabel.textContent : 'Add to cart';
    var stickyBtn = root.querySelector('[data-lp-sticky-add]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-lp-option]'));
    var priceEls = Array.prototype.slice.call(root.querySelectorAll('[data-lp-price-now]'));

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var ok = opts.every(function (val, k) { return v.options[k] === val; });
        if (ok) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      if (!product || !product.variants) return;
      fieldsets.forEach(function (fs, k) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[k] = input.value;
          var v = findVariant(test);
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function render(v) {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, k) {
        var l = fs.querySelector('[data-lp-option-label]');
        if (l) l.textContent = opts[k] || '';
      });
      markAvailability(opts);
      var available = !!(v && v.available);
      if (v) {
        if (idInput) idInput.value = v.id;
        priceEls.forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
        var was = root.querySelector('[data-lp-price-was]');
        var save = root.querySelector('[data-lp-price-save]');
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.hidden = !onSale; if (onSale) was.textContent = formatMoney(v.compare_at_price, moneyFormat); }
        var badge = root.querySelector('[data-lp-badge]');
        if (badge) badge.hidden = !onSale;
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
        if (v.featured_media && goToMedia) goToMedia(v.featured_media.id);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* preview frames have no real URL */ }
      }
      if (addBtn) addBtn.disabled = !available;
      if (stickyBtn) stickyBtn.disabled = !available;
      if (addLabel) addLabel.textContent = v ? (available ? defaultLabel : 'Sold out') : 'Unavailable';
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { render(findVariant(selectedOptions())); });
    });
    if (fieldsets.length) markAvailability(selectedOptions());

    var qty = root.querySelector('[data-lp-qty] input');
    root.querySelectorAll('[data-lp-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-lp-qty-step')));
        qty.value = n;
      });
    });

    var sticky = root.querySelector('[data-lp-sticky]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
    }
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(addBtn || undefined); else form.submit();
      });
    }
    document.querySelectorAll('[data-lp-scroll-buy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var target = root.querySelector('.lp-info') || root;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initBeforeAfter(frame) {
    var range = frame.querySelector('.lp-ba__range');
    if (!range) return;
    function set() { frame.style.setProperty('--pos', range.value + '%'); }
    range.addEventListener('input', set);
    set();
  }

  function init() {
    document.querySelectorAll('[data-lp-product]').forEach(function (root) {
      if (root.__lp) return; root.__lp = true; initProduct(root);
    });
    document.querySelectorAll('[data-lp-ba]').forEach(function (f) {
      if (f.__lp) return; f.__lp = true; initBeforeAfter(f);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
